import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mt-4 p-2 bg-white dark:border-gray-800 rounded-md shadow-md" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "pr-2" }
const _hoisted_5 = { class: "mt-4 p-2 bg-white dark:border-gray-800 rounded-md shadow-md" }
const _hoisted_6 = { class: "grid gap-2 grid-cols-2" }
const _hoisted_7 = { class: "grid gap-2 grid-cols-2" }
const _hoisted_8 = {
  key: 0,
  class: "mt-4 p-2 bg-white dark:border-gray-800 rounded-md shadow-md space-y-2"
}
const _hoisted_9 = { class: "grid gap-2 grid-cols-2 mt-2" }
const _hoisted_10 = { class: "mt-4 p-2 bg-white dark:border-gray-800 rounded-md shadow-md space-y-2" }
const _hoisted_11 = { class: "flex justify-between items-center" }
const _hoisted_12 = { class: "flex justify-between items-center" }
const _hoisted_13 = { class: "flex justify-between items-center" }
const _hoisted_14 = { class: "flex justify-between items-center" }
const _hoisted_15 = { class: "flex justify-between items-center" }
const _hoisted_16 = { class: "flex flex-col gap-2" }
const _hoisted_17 = { class: "flex items-center gap-2 p-2 bg-white dark:border-gray-800 rounded-md shadow-md" }
const _hoisted_18 = { class: "flex items-center gap-2 p-2 bg-white dark:border-gray-800 rounded-md shadow-md" }
const _hoisted_19 = { class: "flex items-center gap-2 p-2 bg-white dark:border-gray-800 rounded-md shadow-md" }
const _hoisted_20 = { class: "flex items-center gap-2" }
const _hoisted_21 = { for: "photoInsurance" }

import { computed, onMounted, ref, watch } from 'vue';
  import { additionalCosts, carData } from '@/types';
  import EditInputCustom from '@/components/components/editInputCustom.vue';
  import { useNotification } from '@kyvg/vue3-notification';
  import {
    calcPensionCost,
    getFreeACopart,
    getFreeAIAAI,
    getLiveBindCopart,
    getLiveBindIAAI,
  } from '@/helpers/helper';
  import { getSession, saveCar } from '@/indexedDB';
  import { useParser } from '@/store/parser';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'mainCalcBlock',
  setup(__props) {

  const { notify } = useNotification();
  const visibleShippingBlock = ref(false);

  const dataCar = ref<carData | null>(null);
  const additionalFields = ref<additionalCosts | null>(null);
  const auction = ref<string>('poland');

  const openInsurensePdf = () => {
    window
      .open('pdf/2023%20Умови%20страхування%20Lion%20Trans.pdf', '_blank')
      .focus();
  };
  const link = localStorage.getItem('link');

  const updatePaymentCost = () => {
    updateAuctionFee();
    updateShippingInsurance();
    updateShippingBodyPrice();
  };
  const updateAuctionFee = () => {
    const priceNow = +dataCar.value?.info?.priceNow || 0;
    if (priceNow > 0) {
      if (link.includes('copart')) {
        dataCar.value.info.auctionFee =
          getLiveBindCopart(priceNow) + getFreeACopart(priceNow) + 95 + 35;
      } else {
        dataCar.value.info.auctionFee =
          getLiveBindIAAI(priceNow) + getFreeAIAAI(priceNow) + 140 + 25;
      }
      saveCar('car', dataCar.value);
    }
  };

  function updateShippingInsurance() {
    const priceNow = +dataCar.value?.info.priceNow || 0;
    if (priceNow > 0) {
      const auctionFee = +dataCar.value?.info.auctionFee || 0;
      const baseCost = priceNow + auctionFee;
      const insuranceCost = baseCost * 0.009;
      dataCar.value.shipping.costShippingInsurance =
        insuranceCost >= 75 ? insuranceCost : 75;
      saveCar('car', dataCar.value);
    }
  }

  function updateShippingBodyPrice() {
    const body = dataCar.value?.shipping.body;
    const mapping: Record<string, number> = {
      Crossover: 100,
      'Large size': 200,
    };
    dataCar.value.shipping.bodyPrice =
      body === 'Non-standard'
        ? dataCar.value?.shipping.cost
        : mapping[body] || 0;
    saveCar('car', dataCar.value);
  }
  const copyVin = (vin: string) => {
    if (
      navigator.clipboard &&
      typeof navigator.clipboard.writeText === 'function'
    ) {
      navigator.clipboard
        .writeText(vin)
        .then(() => {
          notify({
            type: 'success',
            text: 'Copied successfully!',
          });
        })
        .catch((err) => {
          console.error('Failed to copy text: ', err);
          notify({
            type: 'error',
            text: 'Failed to copy. Please try again.',
          });
        });
    } else {
      try {
        const textarea = document.createElement('textarea');
        textarea.value = vin;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);

        notify({
          type: 'success',
          text: 'Copied successfully!',
        });
      } catch (err) {
        console.error('Fallback copy failed: ', err);
        notify({
          type: 'error',
          text: 'Failed to copy. Please try again.',
        });
      }
    }
  };
  const { getCustomClearance } = useParser();

  const calcCustomClearance = async () => {
    additionalFields.value.customsCost = await getCustomClearance(
      auction.value,
      dataCar.value
    );
    await saveCar('additionalFields', additionalFields.value);
  };
  const georgyTotal = computed(() => {
    return (
      +(dataCar.value?.info.auctionFee ?? 0) +
      +(dataCar.value?.info.priceNow ?? 0) +
      +(dataCar.value?.shipping.cost ?? 0) +
      +(dataCar.value?.shipping.bodyPrice ?? 0) +
      +(dataCar.value?.shipping.shippingByPhoto?.[0]
        ? dataCar.value?.shipping.costShippingInsurance ?? 0
        : 0) +
      +(additionalFields.value?.serviceCost ?? 0)
    );
  });
  onMounted(async () => {
    dataCar.value = await getSession('car');
    additionalFields.value = await getSession('additionalFields');
    auction.value = dataCar.value?.info?.countryCalc ?? 'poland';
    updateAuctionFee();
  });
  watch(
    () => dataCar.value?.shipping.body,
    () => {
      updateShippingBodyPrice();
    }
  );

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_RadioButtonGroup = _resolveComponent("RadioButtonGroup")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Drawer = _resolveComponent("Drawer")!

  return (dataCar.value && Object.keys(dataCar.value).length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "font-bold" }, "Vin Code :", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(dataCar.value.info?.vim), 1),
            _createVNode(_component_InputGroup, { class: "w-full" }, {
              default: _withCtx(() => [
                _createVNode(_component_InputText, { placeholder: "vin code" }),
                _createVNode(_component_Button, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (copyVin(dataCar.value.info?.vim + dataCar.value.info.last_6_char))),
                  icon: "pi pi-copy"
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createVNode(EditInputCustom, {
                class: "w-full",
                id: "year",
                type: "number",
                onChange: calcCustomClearance,
                modelValue: dataCar.value.info.yearBorn,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dataCar.value.info.yearBorn) = $event)),
                title: "Year",
                "tooltip-text": "*Check the year of manufacture on the label photo."
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(EditInputCustom, {
                class: "w-full",
                id: "bid",
                type: "number",
                onChange: calcCustomClearance,
                modelValue: dataCar.value.info.priceNow,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dataCar.value.info.priceNow) = $event)),
                onInput: updatePaymentCost,
                title: "Final Bid ($)"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _createVNode(EditInputCustom, {
                id: "auctionFee",
                type: "number",
                modelValue: dataCar.value.info.auctionFee,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dataCar.value.info.auctionFee) = $event)),
                title: "Auction Fee ($)",
                "tooltip-text": "*Clarify the information for Canada."
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(EditInputCustom, {
                id: "bid",
                type: "number",
                modelValue: dataCar.value.shipping.cost,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dataCar.value.shipping.cost) = $event)),
                title: "Port Delivery ($)",
                "is-button": true,
                onInput: updatePaymentCost,
                "button-icon": "pi pi-box",
                onButtonClick: _cache[5] || (_cache[5] = () => (visibleShippingBlock.value = true)),
                "tooltip-text": "*Temporary additional charges are not included."
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        (dataCar.value?.info?.countryCalc === 'georgy' && additionalFields.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", null, [
                  _createVNode(EditInputCustom, {
                    id: "bid",
                    type: "number",
                    title: "Service fee ($)",
                    modelValue: additionalFields.value.serviceCost,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((additionalFields.value.serviceCost) = $event)),
                    "tooltip-text": "*Company services"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", null, [
                  _cache[12] || (_cache[12] = _createElementVNode("div", null, "Total :", -1)),
                  _createElementVNode("div", null, "$" + _toDisplayString(georgyTotal.value), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[13] || (_cache[13] = _createElementVNode("div", null, "Body", -1)),
            _createElementVNode("div", null, [
              _createElementVNode("b", null, _toDisplayString(dataCar.value.shipping.body) + "($" + _toDisplayString(dataCar.value.shipping.bodyPrice) + ")", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[14] || (_cache[14] = _createElementVNode("div", null, "Engine size", -1)),
            _createElementVNode("div", null, [
              _createVNode(_component_InputText, {
                onChange: calcCustomClearance,
                modelValue: dataCar.value.info.eng,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dataCar.value.info.eng) = $event)),
                size: "small"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[15] || (_cache[15] = _createElementVNode("div", null, "Type of fuel", -1)),
            _createElementVNode("div", null, [
              _createElementVNode("b", null, _toDisplayString(dataCar.value.info.typeEng), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[16] || (_cache[16] = _createElementVNode("div", null, "Sales status", -1)),
            _createElementVNode("div", null, [
              _createElementVNode("b", null, _toDisplayString(dataCar.value.info.saleStatus), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[17] || (_cache[17] = _createElementVNode("div", null, "Port of Delivery", -1)),
            _createElementVNode("div", null, [
              _createElementVNode("b", null, _toDisplayString(dataCar.value.shipping.port), 1)
            ])
          ])
        ]),
        _createVNode(_component_Drawer, {
          visible: visibleShippingBlock.value,
          "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((visibleShippingBlock).value = $event)),
          header: "Additional fee for large cars",
          position: "right",
          class: "!bg-gray-50"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_RadioButtonGroup, {
                modelValue: dataCar.value.shipping.body,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((dataCar.value.shipping.body) = $event)),
                class: "flex flex-col gap-4"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_RadioButton, {
                      inputId: "Crossover",
                      value: "Crossover"
                    }),
                    _cache[18] || (_cache[18] = _createElementVNode("label", {
                      for: "Crossover",
                      class: "w-full"
                    }, [
                      _createElementVNode("div", { class: "flex justify-end" }, [
                        _createElementVNode("svg", {
                          width: "119",
                          height: "64",
                          viewBox: "0 0 119 64",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _createElementVNode("g", { "clip-path": "url(#clip0_89_817)" }, [
                            _createElementVNode("path", {
                              d: "M107.568 33.7548V29.5337C107.633 29.0795 107.523 28.6429 107.302 28.2349M107.568 33.7548C108.219 34.7289 109.391 37.3265 108.87 39.924M107.568 33.7548H102.892C101.919 33.7548 100.957 33.4106 100.4 32.613C99.8375 31.8071 99.2498 30.68 98.9477 29.3182C98.8202 28.7435 99.286 28.2349 99.8747 28.2349H107.302M107.302 28.2349C106.637 27.0097 104.978 26.0078 103.987 25.6373C99.6444 24.0138 94.6758 24.0138 89.9878 24.0138C85.2997 24.0138 81.9573 22.715 80.8721 22.0656L63.3575 13.1883C61.8162 12.4071 60.1125 12 58.3845 12H22.8005C22.0307 12 21.2777 12.2258 20.6349 12.6494M108.87 39.924C108.219 43.171 105.615 46.0933 103.987 46.418C103.798 46.4558 102.684 46.418 102.684 46.418C102.684 46.418 103.506 42.9686 102.9 40.2487C102.294 37.5289 99.6219 31.4851 91.29 31.1572C83.0409 30.8325 79.5698 37.0018 79.1342 40.2487C78.6986 43.4957 78.9187 46.418 78.9187 46.418H76.6397M108.87 39.924H105.615M76.6397 46.418H50.595M76.6397 46.418V39.924M2.41234 36.0277C1.29553 36.2133 0.999047 37.8473 1 39.3178C1.00067 40.3495 1.49021 41.3009 2.19831 42.0513L5.13503 45.1633C5.89073 45.9641 6.94312 46.418 8.0442 46.418H9.46454C9.46454 46.418 9.46454 44.9392 9.46454 42.8463C9.46454 40.7534 10.3075 38.6511 10.4412 38.3006M2.41234 36.0277C2.17717 35.3241 1.90801 33.9768 2.16921 32.8913C2.35502 32.119 3.31806 31.8148 3.70547 31.1214C3.90056 30.7722 4.04004 30.2625 4.04004 29.5337M2.41234 36.0277C2.93331 38.3655 7.95366 38.517 10.4412 38.3006M10.4412 38.3006C11.4847 35.5641 14.8889 31.1572 21.1847 31.1572C23.5677 31.1572 25.4999 31.6436 27.0447 32.456M4.04004 29.5337C3.40837 28.9037 2.5239 27.5057 2.69103 25.8902C2.82833 24.5631 3.96297 23.6356 5.07706 22.9015L7.70048 21.1727M4.04004 29.5337H10.8768C12.8657 29.1271 13.7195 27.3677 14.0092 25.9995C14.1253 25.4514 13.6721 24.9879 13.1118 24.9879H8.70048C8.14819 24.9879 7.70048 24.5402 7.70048 23.9879V21.1727M7.70048 21.1727L12.0119 18.3316M20.6349 12.6494L9.88266 13.8418C9.34747 13.9012 8.95166 14.3754 9.06572 14.9016C9.38168 16.3594 10.2258 18.227 12.0119 18.3316M20.6349 12.6494L12.0119 18.3316M50.595 46.418V42.5216M50.595 46.418H33.6659C33.6659 46.418 33.8815 42.8463 33.2304 39.5993M50.595 42.5216V33.1054C50.4865 31.049 50.009 26.3517 48.9672 24.0138M50.595 42.5216C56.4551 42.5216 68.8914 42.5216 71.7563 42.5216C74.6213 42.5216 76.2057 40.7899 76.6397 39.924M50.595 42.5216H43.7583C41.6616 42.5216 40.1979 42.1709 39.1973 41.6813C37.6235 40.9111 35.7518 39.3955 34.0054 39.5367L33.2304 39.5993M33.2304 39.5993C32.5792 37.0018 30.3142 34.1753 27.0447 32.456M48.9672 24.0138H75.0119M48.9672 24.0138H32.3637M48.9672 24.0138C48.8587 21.9574 48.251 17.3251 46.6883 15.247M75.0119 24.0138C76.8553 27.9102 76.6397 38.9499 76.6397 39.924M75.0119 24.0138C75.6595 24.0138 75.8652 23.1405 75.2857 22.8515L61.09 15.7725C60.397 15.4269 59.6338 15.247 58.8593 15.247C55.7928 15.247 51.323 15.247 46.6883 15.247M32.3637 24.0138C30.6274 23.6891 25.7425 21.4162 23.248 16.8705M32.3637 24.0138V15.247M46.6883 15.247C41.5551 15.247 36.2194 15.247 32.3637 15.247M23.248 16.8705V23.4546C23.248 25.7518 23.6398 28.0746 24.8894 30.0021C25.5427 31.0098 26.296 31.9485 27.0447 32.456M23.248 16.8705C23.248 16.0768 24.5503 15.247 32.3637 15.247",
                              stroke: "#292D32",
                              "stroke-width": "1.5"
                            }),
                            _createElementVNode("path", {
                              d: "M31.4036 43.4301C31.4036 48.7852 26.9872 53.15 21.5101 53.15C16.033 53.15 11.6167 48.7852 11.6167 43.4301C11.6167 38.0749 16.033 33.7101 21.5101 33.7101C26.9872 33.7101 31.4036 38.0749 31.4036 43.4301Z",
                              stroke: "#292D32",
                              "stroke-width": "1.7"
                            }),
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              "clip-rule": "evenodd",
                              d: "M28.5697 43.4299C28.5697 47.2661 25.4088 50.3759 21.5097 50.3759C17.6106 50.3759 14.4497 47.2661 14.4497 43.4299C14.4497 39.5938 17.6106 36.484 21.5097 36.484C25.4088 36.484 28.5697 39.5938 28.5697 43.4299ZM22.6244 39.7742C22.6244 40.3799 22.1253 40.8709 21.5096 40.8709C20.894 40.8709 20.3949 40.3799 20.3949 39.7742C20.3949 39.1685 20.894 38.6775 21.5096 38.6775C22.1253 38.6775 22.6244 39.1685 22.6244 39.7742ZM21.5098 44.5267C22.1254 44.5267 22.6245 44.0357 22.6245 43.43C22.6245 42.8243 22.1254 42.3332 21.5098 42.3332C20.8941 42.3332 20.395 42.8243 20.395 43.43C20.395 44.0357 20.8941 44.5267 21.5098 44.5267ZM26.3403 42.6988C26.3403 43.3045 25.8412 43.7955 25.2256 43.7955C24.6099 43.7955 24.1108 43.3045 24.1108 42.6988C24.1108 42.0931 24.6099 41.6021 25.2256 41.6021C25.8412 41.6021 26.3403 42.0931 26.3403 42.6988ZM23.7397 47.4513C24.3554 47.4513 24.8545 46.9603 24.8545 46.3546C24.8545 45.7489 24.3554 45.2579 23.7397 45.2579C23.1241 45.2579 22.625 45.7489 22.625 46.3546C22.625 46.9603 23.1241 47.4513 23.7397 47.4513ZM20.3955 46.3546C20.3955 46.9603 19.8964 47.4513 19.2807 47.4513C18.6651 47.4513 18.166 46.9603 18.166 46.3546C18.166 45.7489 18.6651 45.2579 19.2807 45.2579C19.8964 45.2579 20.3955 45.7489 20.3955 46.3546ZM17.7939 43.7955C18.4096 43.7955 18.9087 43.3045 18.9087 42.6988C18.9087 42.0931 18.4096 41.6021 17.7939 41.6021C17.1783 41.6021 16.6792 42.0931 16.6792 42.6988C16.6792 43.3045 17.1783 43.7955 17.7939 43.7955Z",
                              fill: "#292D32"
                            }),
                            _createElementVNode("path", {
                              d: "M101.073 43.4301C101.073 48.7852 96.6572 53.15 91.1801 53.15C85.703 53.15 81.2866 48.7852 81.2866 43.4301C81.2866 38.0749 85.703 33.7101 91.1801 33.7101C96.6572 33.7101 101.073 38.0749 101.073 43.4301Z",
                              stroke: "#292D32",
                              "stroke-width": "1.7"
                            }),
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              "clip-rule": "evenodd",
                              d: "M98.2396 43.4299C98.2396 47.2661 95.0787 50.3759 91.1796 50.3759C87.2805 50.3759 84.1196 47.2661 84.1196 43.4299C84.1196 39.5938 87.2805 36.484 91.1796 36.484C95.0787 36.484 98.2396 39.5938 98.2396 43.4299ZM92.294 39.7742C92.294 40.3799 91.7949 40.8709 91.1793 40.8709C90.5636 40.8709 90.0646 40.3799 90.0646 39.7742C90.0646 39.1685 90.5636 38.6775 91.1793 38.6775C91.7949 38.6775 92.294 39.1685 92.294 39.7742ZM91.1792 44.5267C91.7948 44.5267 92.2939 44.0357 92.2939 43.43C92.2939 42.8243 91.7948 42.3332 91.1792 42.3332C90.5635 42.3332 90.0645 42.8243 90.0645 43.43C90.0645 44.0357 90.5635 44.5267 91.1792 44.5267ZM96.0102 42.6988C96.0102 43.3045 95.5111 43.7955 94.8955 43.7955C94.2798 43.7955 93.7808 43.3045 93.7808 42.6988C93.7808 42.0931 94.2798 41.6021 94.8955 41.6021C95.5111 41.6021 96.0102 42.0931 96.0102 42.6988ZM93.4092 47.4513C94.0248 47.4513 94.5239 46.9603 94.5239 46.3546C94.5239 45.7489 94.0248 45.2579 93.4092 45.2579C92.7935 45.2579 92.2944 45.7489 92.2944 46.3546C92.2944 46.9603 92.7935 47.4513 93.4092 47.4513ZM90.0649 46.3546C90.0649 46.9603 89.5658 47.4513 88.9502 47.4513C88.3345 47.4513 87.8354 46.9603 87.8354 46.3546C87.8354 45.7489 88.3345 45.2579 88.9502 45.2579C89.5658 45.2579 90.0649 45.7489 90.0649 46.3546ZM87.4634 43.7955C88.079 43.7955 88.5781 43.3045 88.5781 42.6988C88.5781 42.0931 88.079 41.6021 87.4634 41.6021C86.8477 41.6021 86.3486 42.0931 86.3486 42.6988C86.3486 43.3045 86.8477 43.7955 87.4634 43.7955Z",
                              fill: "#292D32"
                            })
                          ]),
                          _createElementVNode("defs", null, [
                            _createElementVNode("clipPath", { id: "clip0_89_817" }, [
                              _createElementVNode("rect", {
                                width: "110",
                                height: "43",
                                fill: "white",
                                transform: "translate(0 11)"
                              })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "flex justify-end" }, "Crossover +50$")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_RadioButton, {
                      inputId: "Large size",
                      value: "Large size"
                    }),
                    _cache[19] || (_cache[19] = _createElementVNode("label", {
                      for: "Large size",
                      class: "w-full"
                    }, [
                      _createElementVNode("div", { class: "flex justify-end" }, [
                        _createElementVNode("svg", {
                          width: "119",
                          height: "64",
                          viewBox: "0 0 119 64",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _createElementVNode("g", { "clip-path": "url(#clip0_95_969)" }, [
                            _createElementVNode("path", {
                              d: "M39.4612 25.1282V42.7657M39.4612 25.1282C39.3943 23.5851 39.5995 20.7506 40.5778 18.2532C41.5472 15.7785 44.2903 14.8397 46.9481 14.8397H61.4278C63.2566 14.8397 65.0509 15.3374 66.6184 16.2795L81.3419 25.1282M39.4612 25.1282H4.22843C3.76467 25.1282 3.38873 25.5042 3.38873 25.9679V28.0679M39.4612 42.7657H58.4145M39.4612 42.7657H33.9586C33.9586 41.3031 33.6181 39.3357 32.7623 37.4744M81.3419 25.1282C81.0362 26.3041 80.4248 30.4195 80.4248 37.4744M81.3419 25.1282C84.5012 25.5202 87.7752 25.7162 94.4868 26.3041C98.1538 26.6253 100.039 26.5434 102.771 27.4799M3.38873 28.0679C4.91727 27.7739 7.97434 28.0091 7.97434 31.3013C7.97434 34.5937 4.91727 34.8288 3.38873 34.5349M3.38873 28.0679V34.5349M58.4145 42.7657H80.4248M58.4145 42.7657V37.4744M32.7623 37.4744H33.9586H58.4145M32.7623 37.4744C31.3247 34.3478 28.4332 31.5208 23.2593 31.8893C18.4217 32.2338 15.8592 34.7663 14.649 37.4744M80.4248 42.7657H82.8704C82.8704 41.8839 83.1022 39.2382 83.948 37.4744M80.4248 42.7657V37.4744M83.948 37.4744H80.4248M83.948 37.4744C85.3308 34.5908 88.08 31.8893 92.6529 31.8893C100.295 31.8893 103.658 38.8463 103.658 42.7657C104.852 42.7657 106.715 42.7657 106.715 42.7657M80.4248 37.4744H58.4145M58.4145 37.4744C57.8163 34.2409 57.8163 29.5377 59.3316 25.7162M59.3316 25.7162V18.0733M59.3316 25.7162H44.3524C44.3524 25.7162 43.9423 25.295 43.741 23.0706C43.5803 21.2953 43.8792 19.7324 44.9321 18.7254C45.4817 18.1996 46.276 18.0733 47.0366 18.0733H59.3316M59.3316 25.7162H65.1022C65.9171 25.7162 66.7065 25.9996 67.3354 26.5179C68.0899 27.1398 69.0373 27.4799 70.0152 27.4799H76.7963C77.6468 27.4799 77.9584 26.3607 77.2301 25.9213L65.4233 18.7976C64.6379 18.3237 63.738 18.0733 62.8206 18.0733H59.3316M102.771 27.4799C103.858 27.8524 104.87 28.3351 105.72 28.957C106.408 29.4601 106.715 30.3058 106.715 31.1582V33.653M102.771 27.4799V31.1339C102.771 32.5252 103.899 33.653 105.29 33.653H106.715M106.715 42.7657H109.16V40.561M106.715 42.7657V40.561M109.16 40.561V38.3564M109.16 40.561H106.715M106.715 40.561V38.3564M109.16 30.1255V38.3564M109.16 38.3564H106.715M106.715 38.3564V33.653M3.38873 37.4744H3.09414C2.14902 37.4744 1.23132 37.9902 0.991546 38.9044C0.713715 39.9637 0.773732 41.0477 1.54215 41.9657C2.05772 42.5817 2.89859 42.7657 3.70184 42.7657H8.12712M3.38873 37.4744V34.5349M3.38873 37.4744H7.97434M8.12712 42.7657H13.7826C13.6139 41.3868 13.7944 39.3869 14.649 37.4744M8.12712 42.7657L7.97434 37.4744M7.97434 37.4744H14.649",
                              stroke: "#292D32",
                              "stroke-width": "1.25954"
                            }),
                            _createElementVNode("path", {
                              d: "M100.575 42.6148C100.575 46.3816 97.3922 49.4771 93.4137 49.4771C89.4344 49.4771 86.252 46.3816 86.252 42.6148C86.252 38.8478 89.4344 35.7524 93.4137 35.7524C97.3922 35.7524 100.575 38.8478 100.575 42.6148Z",
                              stroke: "#292D32",
                              "stroke-width": "1.25954"
                            }),
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              "clip-rule": "evenodd",
                              d: "M98.5321 42.6147C98.5321 45.3337 96.2397 47.538 93.4124 47.538C90.5844 47.538 88.292 45.3337 88.292 42.6147C88.292 39.8956 90.5844 37.6913 93.4124 37.6913C96.2397 37.6913 98.5321 39.8956 98.5321 42.6147ZM94.2211 40.0234C94.2211 40.4527 93.8592 40.8008 93.4124 40.8008C92.9657 40.8008 92.6038 40.4527 92.6038 40.0234C92.6038 39.594 92.9657 39.246 93.4124 39.246C93.8592 39.246 94.2211 39.594 94.2211 40.0234ZM93.4124 43.3921C93.8592 43.3921 94.2211 43.044 94.2211 42.6147C94.2211 42.1853 93.8592 41.8373 93.4124 41.8373C92.9657 41.8373 92.6038 42.1853 92.6038 42.6147C92.6038 43.044 92.9657 43.3921 93.4124 43.3921ZM96.9165 42.0964C96.9165 42.5257 96.5546 42.8738 96.1079 42.8738C95.6612 42.8738 95.2992 42.5257 95.2992 42.0964C95.2992 41.6671 95.6612 41.319 96.1079 41.319C96.5546 41.319 96.9165 41.6671 96.9165 42.0964ZM95.0289 45.465C95.4756 45.465 95.8375 45.117 95.8375 44.6877C95.8375 44.2584 95.4756 43.9103 95.0289 43.9103C94.583 43.9103 94.2202 44.2584 94.2202 44.6877C94.2202 45.117 94.583 45.465 95.0289 45.465ZM92.6038 44.6877C92.6038 45.117 92.2419 45.465 91.796 45.465C91.3493 45.465 90.9874 45.117 90.9874 44.6877C90.9874 44.2584 91.3493 43.9103 91.796 43.9103C92.2419 43.9103 92.6038 44.2584 92.6038 44.6877ZM90.717 42.8738C91.1637 42.8738 91.5257 42.5257 91.5257 42.0964C91.5257 41.6671 91.1637 41.319 90.717 41.319C90.2703 41.319 89.9084 41.6671 89.9084 42.0964C89.9084 42.5257 90.2703 42.8738 90.717 42.8738Z",
                              fill: "#292D32"
                            }),
                            _createElementVNode("path", {
                              d: "M30.8749 42.6148C30.8749 46.3816 27.692 49.4771 23.7133 49.4771C19.7346 49.4771 16.5518 46.3816 16.5518 42.6148C16.5518 38.8478 19.7346 35.7524 23.7133 35.7524C27.692 35.7524 30.8749 38.8478 30.8749 42.6148Z",
                              stroke: "#292D32",
                              "stroke-width": "1.25954"
                            }),
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              "clip-rule": "evenodd",
                              d: "M28.8328 42.6147C28.8328 45.3337 26.5405 47.538 23.7127 47.538C20.8851 47.538 18.5928 45.3337 18.5928 42.6147C18.5928 39.8956 20.8851 37.6913 23.7127 37.6913C26.5405 37.6913 28.8328 39.8956 28.8328 42.6147ZM24.5213 40.0234C24.5213 40.4527 24.1594 40.8008 23.7128 40.8008C23.2663 40.8008 22.9044 40.4527 22.9044 40.0234C22.9044 39.594 23.2663 39.246 23.7128 39.246C24.1594 39.246 24.5213 39.594 24.5213 40.0234ZM23.7128 43.3921C24.1593 43.3921 24.5213 43.044 24.5213 42.6147C24.5213 42.1853 24.1593 41.8373 23.7128 41.8373C23.2663 41.8373 22.9044 42.1853 22.9044 42.6147C22.9044 43.044 23.2663 43.3921 23.7128 43.3921ZM27.2166 42.0964C27.2166 42.5257 26.8547 42.8738 26.4082 42.8738C25.9617 42.8738 25.5998 42.5257 25.5998 42.0964C25.5998 41.6671 25.9617 41.319 26.4082 41.319C26.8547 41.319 27.2166 41.6671 27.2166 42.0964ZM25.3303 45.465C25.7768 45.465 26.1387 45.117 26.1387 44.6877C26.1387 44.2584 25.7768 43.9103 25.3303 43.9103C24.8839 43.9103 24.5219 44.2584 24.5219 44.6877C24.5219 45.117 24.8839 45.465 25.3303 45.465ZM22.905 44.6877C22.905 45.117 22.543 45.465 22.0966 45.465C21.6501 45.465 21.2881 45.117 21.2881 44.6877C21.2881 44.2584 21.6501 43.9103 22.0966 43.9103C22.543 43.9103 22.905 44.2584 22.905 44.6877ZM21.0182 42.8738C21.4647 42.8738 21.8267 42.5257 21.8267 42.0964C21.8267 41.6671 21.4647 41.319 21.0182 41.319C20.5718 41.319 20.2099 41.6671 20.2099 42.0964C20.2099 42.5257 20.5718 42.8738 21.0182 42.8738Z",
                              fill: "#292D32"
                            })
                          ]),
                          _createElementVNode("defs", null, [
                            _createElementVNode("clipPath", { id: "clip0_95_969" }, [
                              _createElementVNode("rect", {
                                width: "110",
                                height: "36.1069",
                                fill: "white",
                                transform: "translate(0 14)"
                              })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "flex justify-end" }, "Large size +200$")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_RadioButton, {
                      inputId: "Non-standard",
                      value: "Non-standard"
                    }),
                    _cache[20] || (_cache[20] = _createElementVNode("label", {
                      for: "Non-standard",
                      class: "w-full"
                    }, [
                      _createElementVNode("div", { class: "flex justify-end" }, [
                        _createElementVNode("svg", {
                          width: "118",
                          height: "64",
                          viewBox: "0 0 118 64",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _createElementVNode("g", { "clip-path": "url(#clip0_95_892)" }, [
                            _createElementVNode("path", {
                              d: "M93.3097 43.104C93.3097 46.8597 90.1896 49.9292 86.3109 49.9292C82.4312 49.9292 79.3115 46.8597 79.3115 43.104C79.3115 39.3484 82.4312 36.2789 86.3109 36.2789C90.1896 36.2789 93.3097 39.3484 93.3097 43.104Z",
                              stroke: "#292D32",
                              "stroke-width": "1.27559"
                            }),
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              "clip-rule": "evenodd",
                              d: "M91.3282 43.1038C91.3282 45.8123 89.0815 48.008 86.31 48.008C83.5383 48.008 81.2915 45.8123 81.2915 43.1038C81.2915 40.3953 83.5383 38.1996 86.31 38.1996C89.0815 38.1996 91.3282 40.3953 91.3282 43.1038ZM87.1026 40.5226C87.1026 40.9503 86.748 41.297 86.31 41.297C85.8721 41.297 85.5174 40.9503 85.5174 40.5226C85.5174 40.0949 85.8721 39.7482 86.31 39.7482C86.748 39.7482 87.1026 40.0949 87.1026 40.5226ZM86.31 43.8782C86.748 43.8782 87.1026 43.5315 87.1026 43.1038C87.1026 42.6761 86.748 42.3295 86.31 42.3295C85.8721 42.3295 85.5174 42.6761 85.5174 43.1038C85.5174 43.5315 85.8721 43.8782 86.31 43.8782ZM89.7448 42.5876C89.7448 43.0153 89.3893 43.362 88.9522 43.362C88.5142 43.362 88.1596 43.0153 88.1596 42.5876C88.1596 42.16 88.5142 41.8132 88.9522 41.8132C89.3893 41.8132 89.7448 42.16 89.7448 42.5876ZM87.8943 45.9431C88.3323 45.9431 88.6869 45.5965 88.6869 45.1688C88.6869 44.7412 88.3323 44.3944 87.8943 44.3944C87.4572 44.3944 87.1026 44.7412 87.1026 45.1688C87.1026 45.5965 87.4572 45.9431 87.8943 45.9431ZM85.5174 45.1688C85.5174 45.5965 85.1628 45.9431 84.7255 45.9431C84.2879 45.9431 83.9331 45.5965 83.9331 45.1688C83.9331 44.7412 84.2879 44.3944 84.7255 44.3944C85.1628 44.3944 85.5174 44.7412 85.5174 45.1688ZM83.6682 43.362C84.1058 43.362 84.4606 43.0153 84.4606 42.5876C84.4606 42.16 84.1058 41.8132 83.6682 41.8132C83.2305 41.8132 82.8758 42.16 82.8758 42.5876C82.8758 43.0153 83.2305 43.362 83.6682 43.362Z",
                              fill: "#292D32"
                            }),
                            _createElementVNode("path", {
                              d: "M27.1236 43.104C27.1236 46.8597 24.0039 49.9292 20.1245 49.9292C16.2452 49.9292 13.1255 46.8597 13.1255 43.104C13.1255 39.3484 16.2452 36.2789 20.1245 36.2789C24.0039 36.2789 27.1236 39.3484 27.1236 43.104Z",
                              stroke: "#292D32",
                              "stroke-width": "1.27559"
                            }),
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              "clip-rule": "evenodd",
                              d: "M25.1425 43.1038C25.1425 45.8123 22.8957 48.008 20.124 48.008C17.3524 48.008 15.1055 45.8123 15.1055 43.1038C15.1055 40.3953 17.3524 38.1996 20.124 38.1996C22.8957 38.1996 25.1425 40.3953 25.1425 43.1038ZM20.9165 40.5226C20.9165 40.9503 20.5617 41.297 20.1241 41.297C19.6864 41.297 19.3317 40.9503 19.3317 40.5226C19.3317 40.0949 19.6864 39.7482 20.1241 39.7482C20.5617 39.7482 20.9165 40.0949 20.9165 40.5226ZM20.1241 43.8782C20.5617 43.8782 20.9165 43.5315 20.9165 43.1038C20.9165 42.6761 20.5617 42.3295 20.1241 42.3295C19.6865 42.3295 19.3317 42.6761 19.3317 43.1038C19.3317 43.5315 19.6865 43.8782 20.1241 43.8782ZM23.5584 42.5876C23.5584 43.0153 23.2037 43.362 22.766 43.362C22.3284 43.362 21.9736 43.0153 21.9736 42.5876C21.9736 42.16 22.3284 41.8132 22.766 41.8132C23.2037 41.8132 23.5584 42.16 23.5584 42.5876ZM21.7087 45.9431C22.1463 45.9431 22.5011 45.5965 22.5011 45.1688C22.5011 44.7412 22.1463 44.3944 21.7087 44.3944C21.2711 44.3944 20.9163 44.7412 20.9163 45.1688C20.9163 45.5965 21.2711 45.9431 21.7087 45.9431ZM19.3318 45.1688C19.3318 45.5965 18.9771 45.9431 18.5394 45.9431C18.1018 45.9431 17.747 45.5965 17.747 45.1688C17.747 44.7412 18.1018 44.3944 18.5394 44.3944C18.9771 44.3944 19.3318 44.7412 19.3318 45.1688ZM17.4822 43.362C17.9198 43.362 18.2745 43.0153 18.2745 42.5876C18.2745 42.16 17.9198 41.8132 17.4822 41.8132C17.0445 41.8132 16.6898 42.16 16.6898 42.5876C16.6898 43.0153 17.0445 43.362 17.4822 43.362Z",
                              fill: "#292D32"
                            }),
                            _createElementVNode("path", {
                              d: "M31.1449 44.5254H28.963C29.2054 41.0359 27.7614 34.057 19.8716 34.057C11.9818 34.057 10.5377 41.0359 10.7801 44.5254C6.56851 44.5254 4.19079 44.1524 2.86859 43.7179C1.67694 43.3263 1.17989 42.1043 1.0227 40.8599C0.71569 38.4294 0.690689 35.501 2.05227 35.501M31.1449 44.5254C31.6298 42.8408 31.7268 38.2444 28.2356 33.3351C24.7445 28.4258 24.5991 25.5139 24.9627 24.6716M31.1449 44.5254H50.4189M2.05227 35.501C3.79783 35.501 4.2342 33.5758 4.23418 32.6131M2.05227 35.501C1.68861 36.8245 2.41594 39.3273 8.23449 38.7497M24.9627 24.6716H23.1445M24.9627 24.6716H26.7811M50.4189 44.5254C50.6614 40.4344 50.6371 29.8697 48.6006 24.6716M50.4189 44.5254H73.6931M23.1445 24.6716C23.2657 22.2651 23.2899 17.0911 22.4172 15.6472M23.1445 24.6716H13.6894C13.6894 22.5058 15.4349 17.6686 22.4172 15.6472M26.7811 24.6716H45.6914M26.7811 24.6716C27.1471 22.4597 27.5876 17.547 26.421 15.2587M48.6006 24.6716H50.4189M48.6006 24.6716H45.6914M73.6931 44.5254H76.966C76.7237 40.7953 78.8951 34.057 86.4215 34.057C93.9474 34.057 95.6338 41.2766 95.513 44.5254H100.532C104.068 44.5254 106.825 41.4612 106.452 37.9449L106.423 37.6668M73.6931 44.5254C73.9355 40.314 74.1295 31.097 72.9658 27.9204M50.4189 24.6716H67.1473M50.4189 24.6716C50.2977 22.9446 49.5462 19.5685 47.5097 15.2587M45.6914 24.6716C45.5702 21.8725 44.8914 16.7774 43.1458 14.9916M106.423 37.6668C106.869 35.0076 105.695 32.456 103.185 31.4698C102.931 31.3699 102.676 31.2698 102.422 31.1692M106.423 37.6668C97.6951 36.9448 96.6041 34.779 96.6041 32.6131C96.6041 30.8804 100.967 31.2122 102.422 31.1692M72.9658 27.9204C71.1475 28.013 66.7837 28.2814 67.1473 24.6716M72.9658 27.9204C73.395 27.7074 74.2039 26.4576 73.3757 24.6716M67.1473 24.6716C67.8296 23.317 68.1919 23.5509 72.1371 23.8831C72.6601 23.9271 73.155 24.1955 73.3757 24.6716M73.3757 24.6716L75.5115 24.8046M22.4172 15.6472C23.7627 15.4931 25.0991 15.3644 26.421 15.2587M22.4172 15.6472L14.7804 16.0931M26.421 15.2587C32.477 14.7743 38.2259 14.7699 43.1458 14.9916M14.7804 16.0931L11.7475 16.2702C10.7959 16.3257 10.0527 17.1136 10.0527 18.0668C10.0527 18.7885 9.6184 19.4339 8.98316 19.7762C7.17532 20.7504 4.71113 22.5412 4.23418 24.6716M14.7804 16.0931C14.6591 17.5087 14.1257 20.4121 12.9621 20.7009C11.7984 20.9896 9.32544 24.1014 8.23449 25.6213M4.23418 24.6716C3.65234 27.2707 3.99174 31.0489 4.23418 32.6131M4.23418 24.6716L8.23449 25.6213M4.23418 32.6131C8.5981 32.0355 8.71936 27.7113 8.23449 25.6213M47.5097 15.2587C51.5207 15.5708 56.1423 16.0073 58.0558 16.3691C60.9651 16.7301 66.5654 18.3906 71.5112 22.1448C73.07 23.328 74.3928 24.1838 75.5115 24.8046M47.5097 15.2587C46.1471 15.1527 44.6871 15.0611 43.1458 14.9916M75.5115 24.8046C77.9421 26.1537 79.4089 26.3941 80.239 26.4765C80.239 26.4765 89.6938 27.9204 93.3309 28.6424C96.9672 29.3644 100.726 30.7428 102.422 31.1692",
                              stroke: "#292D32",
                              "stroke-width": "1.27559"
                            })
                          ]),
                          _createElementVNode("defs", null, [
                            _createElementVNode("clipPath", { id: "clip0_95_892" }, [
                              _createElementVNode("rect", {
                                width: "108",
                                height: "36.5669",
                                fill: "white",
                                transform: "translate(0 14)"
                              })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", { class: "flex justify-end" }, "Non-standard X2")
                    ], -1))
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_Checkbox, {
                    modelValue: dataCar.value.shipping.shippingByPhoto,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dataCar.value.shipping.shippingByPhoto) = $event)),
                    inputId: "photoInsurance",
                    value: true
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", _hoisted_21, " Insurance based on photos from the auction ($" + _toDisplayString(dataCar.value.shipping.costShippingInsurance) + ") ", 1)
                ])
              ]),
              _createElementVNode("div", {
                class: "flex justify-between",
                onClick: openInsurensePdf
              }, _cache[21] || (_cache[21] = [
                _createTextVNode(" Insurance terms and conditions "),
                _createElementVNode("svg", {
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20V20ZM11 15H13V17H11V15ZM13 13.355V14H11V12.5C11 12.2348 11.1054 11.9804 11.2929 11.7929C11.4804 11.6054 11.7348 11.5 12 11.5C12.2841 11.5 12.5623 11.4193 12.8023 11.2673C13.0423 11.1154 13.2343 10.8984 13.3558 10.6416C13.4773 10.3848 13.5234 10.0988 13.4887 9.81684C13.454 9.53489 13.34 9.26858 13.1598 9.04891C12.9797 8.82924 12.7409 8.66523 12.4712 8.57597C12.2015 8.48671 11.912 8.47587 11.6364 8.54471C11.3608 8.61354 11.1104 8.75923 10.9144 8.96482C10.7183 9.1704 10.5847 9.42743 10.529 9.706L8.567 9.313C8.68863 8.70508 8.96951 8.14037 9.38092 7.67659C9.79233 7.2128 10.3195 6.86658 10.9086 6.67332C11.4977 6.48006 12.1275 6.44669 12.7337 6.57661C13.3399 6.70654 13.9007 6.99511 14.3588 7.41282C14.8169 7.83054 15.1559 8.36241 15.3411 8.95406C15.5263 9.54572 15.5511 10.1759 15.4129 10.7803C15.2747 11.3847 14.9785 11.9415 14.5545 12.3939C14.1306 12.8462 13.5941 13.1779 13 13.355V13.355Z",
                    fill: "#DB2D35"
                  })
                ], -1)
              ]))
            ])
          ]),
          _: 1
        }, 8, ["visible"])
      ]))
    : _createCommentVNode("", true)
}
}

})